module.exports = __webpack_public_path__ + "static/a12-f7ad6a56e7ae53b205368fd91547099c.jpg";